import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { ChartComponentBase } from '../chart.types';
import { FormatNumberPipe } from 'app/shared/pipes/format-number.pipe';
import formatNumber from 'accounting-js/lib/formatNumber.js';

@Component({
  selector: 'chart-metric',
  templateUrl: './metric.component.html',
  styleUrls: ['./metric.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartMetricComponent extends ChartComponentBase {
  /**
   * The sum. avg, count of the value
   */
  public attributeValue: any = '';
  public attributeLabel: string = '';

  constructor(private readonly formatNumber: FormatNumberPipe) {
    super();
  }

  prepareChart(): void {
    if (this.chartDef.series) {
      for (let key of Object.keys(this.chartDef.data)) {
        this.attributeLabel = key;

        for (let key2 of Object.keys(this.chartDef.data[key])) {
          this.attributeValue += this.chartDef.data[key][key2];
        }
      }
      if (this.chartDef.summary_type == 'total') {
        this.attributeLabel = 'Total # of Records';
      } else if (this.chartDef.summary_type == 'sum') {
        this.attributeLabel = `Total ${this.attributeLabel}`;
      } else if (this.chartDef.summary_type == 'average') {
        this.attributeLabel = `Average ${this.attributeLabel}`;
      }
      this.attributeValue = this.formatter(this.attributeValue);
    }
  }

  private formatter(val: any): string {
    if (Number.isNaN(Number(val))) {
      return val;
    }

    if (this.chartDef.formatting && this.chartDef.formatting?.type) {
      if (this.chartDef.formatting?.type == 'number') {
        //return this.formatNumber.transform('23232223.45', 0);
        return formatNumber(val.toString(), {
          precision: 0,
        });
      } else if (this.chartDef.formatting?.type == 'percent') {
        let formattedValue = formatNumber(val.toString(), {
          precision: 2,
        });
        return formattedValue + '%';
      } else if (this.chartDef.formatting?.type == 'money') {
        let formattedValue = formatNumber(val.toString(), {
          precision: 2,
        });
        return '$' + formattedValue;
      }
    } else {
      let formattedValue = formatNumber(val.toString(), {
        precision: 2,
      });
      return formattedValue;
    }
  }
}
